import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface PastExamData {
  label: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class PastExamsDataService {
  public readonly schools: string[];

  public readonly grades: PastExamData[];

  public readonly examTypes: PastExamData[];

  public readonly papers: PastExamData[];

  constructor(private translate: TranslateService) {
    this.schools = [
      'ADMIRALTY PRIMARY SCHOOL',
      'AHMAD IBRAHIM PRIMARY SCHOOL',
      'AI TONG SCHOOL',
      'ALEXANDRA PRIMARY SCHOOL',
      'ANCHOR GREEN PRIMARY SCHOOL',
      'ANDERSON PRIMARY SCHOOL',
      'ANG MO KIO PRIMARY SCHOOL',
      'ANGLO-CHINESE SCHOOL (JUNIOR)',
      'ANGLO-CHINESE SCHOOL (PRIMARY)',
      'ANGSANA PRIMARY SCHOOL',
      'BALESTIER HILL PRIMARY SCHOOL',
      'BEACON PRIMARY SCHOOL',
      'BEDOK GREEN PRIMARY SCHOOL',
      'BENDEMEER PRIMARY SCHOOL',
      'BLANGAH RISE PRIMARY SCHOOL',
      'BOON LAY GARDEN PRIMARY SCHOOL',
      'BUKIT PANJANG PRIMARY SCHOOL',
      'BUKIT TIMAH PRIMARY SCHOOL',
      'BUKIT VIEW PRIMARY SCHOOL',
      'CANBERRA PRIMARY SCHOOL',
      'CANOSSA CONVENT PRIMARY SCHOOL',
      'CANTONMENT PRIMARY SCHOOL',
      'CASUARINA PRIMARY SCHOOL',
      'CEDAR PRIMARY SCHOOL',
      'CHANGKAT PRIMARY SCHOOL',
      'CHIJ (KATONG) PRIMARY',
      'CHIJ (KELLOCK)',
      'CHIJ OUR LADY OF GOOD COUNSEL',
      'CHIJ OUR LADY OF THE NATIVITY',
      'CHIJ OUR LADY QUEEN OF PEACE',
      'CHIJ PRIMARY (TOA PAYOH)',
      'CHONGFU SCHOOL',
      'CHONGZHENG PRIMARY SCHOOL',
      'CHUA CHU KANG PRIMARY SCHOOL',
      'CLEMENTI PRIMARY SCHOOL',
      'COMPASSVALE PRIMARY SCHOOL',
      'CONCORD PRIMARY SCHOOL',
      'CORAL PRIMARY SCHOOL',
      'CORPORATION PRIMARY SCHOOL',
      'DA QIAO PRIMARY SCHOOL',
      'DAMAI PRIMARY SCHOOL',
      'DAZHONG PRIMARY SCHOOL',
      'DE LA SALLE SCHOOL',
      'EAST COAST PRIMARY SCHOOL',
      'EAST SPRING PRIMARY SCHOOL',
      'EAST VIEW PRIMARY SCHOOL',
      'EDGEFIELD PRIMARY SCHOOL',
      'ELIAS PARK PRIMARY SCHOOL',
      'ENDEAVOUR PRIMARY SCHOOL',
      'EUNOIA JUNIOR COLLEGE',
      'EUNOS PRIMARY SCHOOL',
      'EVERGREEN PRIMARY SCHOOL',
      'FAIRFIELD METHODIST SCHOOL (PRIMARY)',
      'FARRER PARK PRIMARY SCHOOL',
      'FENGSHAN PRIMARY SCHOOL',
      'FERNVALE PRIMARY SCHOOL',
      'FIRST TOA PAYOH PRIMARY SCHOOL',
      'FRONTIER PRIMARY SCHOOL',
      'FUCHUN PRIMARY SCHOOL',
      'FUHUA PRIMARY SCHOOL',
      'GAN ENG SENG PRIMARY SCHOOL',
      'GEYLANG METHODIST SCHOOL (PRIMARY)',
      'GONGSHANG PRIMARY SCHOOL',
      'GREENDALE PRIMARY SCHOOL',
      'GREENRIDGE PRIMARY SCHOOL',
      'GREENWOOD PRIMARY SCHOOL',
      'GUANGYANG PRIMARY SCHOOL',
      "HAIG GIRLS' SCHOOL",
      'HENRY PARK PRIMARY SCHOOL',
      "HOLY INNOCENTS' PRIMARY SCHOOL",
      'HONG WEN SCHOOL',
      'HORIZON PRIMARY SCHOOL',
      'HOUGANG PRIMARY SCHOOL',
      'HUAMIN PRIMARY SCHOOL',
      'INNOVA PRIMARY SCHOOL',
      'JIEMIN PRIMARY SCHOOL',
      'JING SHAN PRIMARY SCHOOL',
      'JUNYUAN PRIMARY SCHOOL',
      'JURONG PRIMARY SCHOOL',
      'JURONG WEST PRIMARY SCHOOL',
      'JUYING PRIMARY SCHOOL',
      'KEMING PRIMARY SCHOOL',
      'KHENG CHENG SCHOOL',
      'KONG HWA SCHOOL',
      'KRANJI PRIMARY SCHOOL',
      'KUO CHUAN PRESBYTERIAN PRIMARY SCHOOL',
      'LAKESIDE PRIMARY SCHOOL',
      'LIANHUA PRIMARY SCHOOL',
      'LOYANG PRIMARY SCHOOL',
      'MACPHERSON PRIMARY SCHOOL',
      'MAHA BODHI SCHOOL',
      'MARSILING PRIMARY SCHOOL',
      'MARYMOUNT CONVENT SCHOOL',
      'MAYFLOWER PRIMARY SCHOOL',
      'MEE TOH SCHOOL',
      'MERIDIAN PRIMARY SCHOOL',
      'MONTFORT JUNIOR SCHOOL',
      'NAN CHIAU PRIMARY SCHOOL',
      'NAN HUA PRIMARY SCHOOL',
      'NANYANG PRIMARY SCHOOL',
      'NAVAL BASE PRIMARY SCHOOL',
      'NEW TOWN PRIMARY SCHOOL',
      'NGEE ANN PRIMARY SCHOOL',
      'NORTH SPRING PRIMARY SCHOOL',
      'NORTH VIEW PRIMARY SCHOOL',
      'NORTH VISTA PRIMARY SCHOOL',
      'NORTHLAND PRIMARY SCHOOL',
      'NORTHOAKS PRIMARY SCHOOL',
      'OASIS PRIMARY SCHOOL',
      'OPERA ESTATE PRIMARY SCHOOL',
      'PALM VIEW PRIMARY SCHOOL',
      'PARK VIEW PRIMARY SCHOOL',
      'PASIR RIS PRIMARY SCHOOL',
      "PAYA LEBAR METHODIST GIRLS' SCHOOL (PRIMARY)",
      'PEI CHUN PUBLIC SCHOOL',
      'PEI HWA PRESBYTERIAN PRIMARY SCHOOL',
      'PEI TONG PRIMARY SCHOOL',
      'PEIYING PRIMARY SCHOOL',
      'PIONEER PRIMARY SCHOOL',
      'POI CHING SCHOOL',
      'PRINCESS ELIZABETH PRIMARY SCHOOL',
      'PUNGGOL COVE PRIMARY SCHOOL',
      'PUNGGOL GREEN PRIMARY SCHOOL',
      'PUNGGOL PRIMARY SCHOOL',
      'PUNGGOL VIEW PRIMARY SCHOOL',
      'QIFA PRIMARY SCHOOL',
      'QIHUA PRIMARY SCHOOL',
      'QUEENSTOWN PRIMARY SCHOOL',
      'RADIN MAS PRIMARY SCHOOL',
      "RAFFLES GIRLS' PRIMARY SCHOOL",
      'RED SWASTIKA SCHOOL',
      'RIVER VALLEY PRIMARY SCHOOL',
      'RIVERSIDE PRIMARY SCHOOL',
      'RIVERVALE PRIMARY SCHOOL',
      'ROSYTH SCHOOL',
      'RULANG PRIMARY SCHOOL',
      'SEMBAWANG PRIMARY SCHOOL',
      'SENG KANG PRIMARY SCHOOL',
      'SENGKANG GREEN PRIMARY SCHOOL',
      'SHUQUN PRIMARY SCHOOL',
      'SI LING PRIMARY SCHOOL',
      'SOUTH VIEW PRIMARY SCHOOL',
      'SPRINGDALE PRIMARY SCHOOL',
      "ST. ANDREW'S JUNIOR SCHOOL",
      "ST. ANTHONY'S CANOSSIAN PRIMARY SCHOOL",
      "ST. ANTHONY'S PRIMARY SCHOOL",
      "ST. GABRIEL'S PRIMARY SCHOOL",
      "ST. HILDA'S PRIMARY SCHOOL",
      "ST. JOSEPH'S INSTITUTION JUNIOR",
      "ST. MARGARET'S PRIMARY SCHOOL",
      "ST. STEPHEN'S SCHOOL",
      'STAMFORD PRIMARY SCHOOL',
      'TAMPINES NORTH PRIMARY SCHOOL',
      'TAMPINES PRIMARY SCHOOL',
      'TANJONG KATONG PRIMARY SCHOOL',
      'TAO NAN SCHOOL',
      'TECK GHEE PRIMARY SCHOOL',
      'TECK WHYE PRIMARY SCHOOL',
      'TELOK KURAU PRIMARY SCHOOL',
      'TEMASEK PRIMARY SCHOOL',
      'TOWNSVILLE PRIMARY SCHOOL',
      'UNITY PRIMARY SCHOOL',
      'WATERWAY PRIMARY SCHOOL',
      'WELLINGTON PRIMARY SCHOOL',
      'WEST GROVE PRIMARY SCHOOL',
      'WEST SPRING PRIMARY SCHOOL',
      'WEST VIEW PRIMARY SCHOOL',
      'WESTWOOD PRIMARY SCHOOL',
      'WHITE SANDS PRIMARY SCHOOL',
      'WOODGROVE PRIMARY SCHOOL',
      'WOODLANDS PRIMARY SCHOOL',
      'WOODLANDS RING PRIMARY SCHOOL',
      'XINGHUA PRIMARY SCHOOL',
      'XINGNAN PRIMARY SCHOOL',
      'XINMIN PRIMARY SCHOOL',
      'XISHAN PRIMARY SCHOOL',
      'YANGZHENG PRIMARY SCHOOL',
      'YEW TEE PRIMARY SCHOOL',
      'YIO CHU KANG PRIMARY SCHOOL',
      'YISHUN PRIMARY SCHOOL',
      'YU NENG PRIMARY SCHOOL',
      'YUHUA PRIMARY SCHOOL',
      'YUMIN PRIMARY SCHOOL',
      'ZHANGDE PRIMARY SCHOOL',
      'ZHENGHUA PRIMARY SCHOOL',
      'ZHONGHUA PRIMARY SCHOOL',
      'ADMIRALTY SECONDARY SCHOOL',
      'AHMAD IBRAHIM SECONDARY SCHOOL',
      'ANDERSON SECONDARY SCHOOL',
      'ANG MO KIO SECONDARY SCHOOL',
      'ANGLICAN HIGH SCHOOL',
      'ANGLO-CHINESE SCHOOL (BARKER ROAD)',
      'ASSUMPTION ENGLISH SCHOOL',
      'ASSUMPTION PATHWAY SCHOOL',
      'BALESTIER HILL SECONDARY SCHOOL',
      'BARTLEY SECONDARY SCHOOL',
      'BEATTY SECONDARY SCHOOL',
      'BEDOK GREEN SECONDARY SCHOOL',
      'BEDOK NORTH SECONDARY SCHOOL',
      'BEDOK SOUTH SECONDARY SCHOOL',
      'BEDOK VIEW SECONDARY SCHOOL',
      'BENDEMEER SECONDARY SCHOOL',
      'BISHAN PARK SECONDARY SCHOOL',
      'BOON LAY SECONDARY SCHOOL',
      'BOWEN SECONDARY SCHOOL',
      'BROADRICK SECONDARY SCHOOL',
      'BUKIT BATOK SECONDARY SCHOOL',
      'BUKIT MERAH SECONDARY SCHOOL',
      'BUKIT PANJANG GOVT. HIGH SCHOOL',
      'BUKIT VIEW SECONDARY SCHOOL',
      'CANBERRA SECONDARY SCHOOL',
      "CEDAR GIRLS' SECONDARY SCHOOL",
      'CHANGKAT CHANGI SECONDARY SCHOOL',
      'CHIJ KATONG CONVENT',
      'CHIJ SECONDARY (TOA PAYOH)',
      "CHIJ ST. JOSEPH'S CONVENT",
      "CHIJ ST. THERESA'S CONVENT",
      'CHONG BOON SECONDARY SCHOOL',
      'CHRIST CHURCH SECONDARY SCHOOL',
      'CHUA CHU KANG SECONDARY SCHOOL',
      'CHUNG CHENG HIGH SCHOOL (MAIN)',
      'CHUNG CHENG HIGH SCHOOL (YISHUN)',
      'CLEMENTI TOWN SECONDARY SCHOOL',
      'COMMONWEALTH SECONDARY SCHOOL',
      'COMPASSVALE SECONDARY SCHOOL',
      'CORAL SECONDARY SCHOOL',
      "CRESCENT GIRLS' SCHOOL",
      'CREST SECONDARY SCHOOL',
      'DAMAI SECONDARY SCHOOL',
      'DEYI SECONDARY SCHOOL',
      'DUNEARN SECONDARY SCHOOL',
      'DUNMAN SECONDARY SCHOOL',
      'EAST SPRING SECONDARY SCHOOL',
      'EAST VIEW SECONDARY SCHOOL',
      'EDGEFIELD SECONDARY SCHOOL',
      'EVERGREEN SECONDARY SCHOOL',
      'FAIRFIELD METHODIST SCHOOL (SECONDARY)',
      'FAJAR SECONDARY SCHOOL',
      'FUCHUN SECONDARY SCHOOL',
      'FUHUA SECONDARY SCHOOL',
      'GAN ENG SENG SCHOOL',
      'GEYLANG METHODIST SCHOOL (SECONDARY)',
      'GREENDALE SECONDARY SCHOOL',
      'GREENRIDGE SECONDARY SCHOOL',
      'GREENVIEW SECONDARY SCHOOL',
      'GUANGYANG SECONDARY SCHOOL',
      'HAI SING CATHOLIC SCHOOL',
      'HENDERSON SECONDARY SCHOOL',
      'HILLGROVE SECONDARY SCHOOL',
      "HOLY INNOCENTS' HIGH SCHOOL",
      'HONG KAH SECONDARY SCHOOL',
      'HOUGANG SECONDARY SCHOOL',
      'HUA YI SECONDARY SCHOOL',
      'JUNYUAN SECONDARY SCHOOL',
      'JURONG SECONDARY SCHOOL',
      'JURONG WEST SECONDARY SCHOOL',
      'JURONGVILLE SECONDARY SCHOOL',
      'JUYING SECONDARY SCHOOL',
      'KENT RIDGE SECONDARY SCHOOL',
      'KRANJI SECONDARY SCHOOL',
      'KUO CHUAN PRESBYTERIAN SECONDARY SCHOOL',
      'LOYANG SECONDARY SCHOOL',
      'MACPHERSON SECONDARY SCHOOL',
      'MANJUSRI SECONDARY SCHOOL',
      'MARSILING SECONDARY SCHOOL',
      'MAYFLOWER SECONDARY SCHOOL',
      'MONTFORT SECONDARY SCHOOL',
      'NAN CHIAU HIGH SCHOOL',
      'NAN HUA HIGH SCHOOL',
      "NANYANG GIRLS' HIGH SCHOOL",
      'NAVAL BASE SECONDARY SCHOOL',
      'NEW TOWN SECONDARY SCHOOL',
      'NGEE ANN SECONDARY SCHOOL',
      'NORTH VIEW SECONDARY SCHOOL',
      'NORTH VISTA SECONDARY SCHOOL',
      'NORTHBROOKS SECONDARY SCHOOL',
      'NORTHLAND SECONDARY SCHOOL',
      'NORTHLIGHT SCHOOL',
      'ORCHID PARK SECONDARY SCHOOL',
      'OUTRAM SECONDARY SCHOOL',
      'PASIR RIS CREST SECONDARY SCHOOL',
      'PASIR RIS SECONDARY SCHOOL',
      "PAYA LEBAR METHODIST GIRLS' SCHOOL (SECONDARY)",
      'PEI HWA SECONDARY SCHOOL',
      'PEICAI SECONDARY SCHOOL',
      'PEIRCE SECONDARY SCHOOL',
      'PING YI SECONDARY SCHOOL',
      'PIONEER SECONDARY SCHOOL',
      'PRESBYTERIAN HIGH SCHOOL',
      'PUNGGOL SECONDARY SCHOOL',
      'QUEENSTOWN SECONDARY SCHOOL',
      'QUEENSWAY SECONDARY SCHOOL',
      "RAFFLES GIRLS' SCHOOL (SECONDARY)",
      'REGENT SECONDARY SCHOOL',
      'RIVERSIDE SECONDARY SCHOOL',
      'SCHOOL OF SCIENCE AND TECHNOLOGY, SINGAPORE',
      'SEMBAWANG SECONDARY SCHOOL',
      'SENG KANG SECONDARY SCHOOL',
      'SERANGOON GARDEN SECONDARY SCHOOL',
      'SERANGOON SECONDARY SCHOOL',
      'SHUQUN SECONDARY SCHOOL',
      'SI LING SECONDARY SCHOOL',
      'SIGLAP SECONDARY SCHOOL',
      'SPECTRA SECONDARY SCHOOL',
      'SPRINGFIELD SECONDARY SCHOOL',
      "ST. ANDREW'S SECONDARY SCHOOL",
      "ST. ANTHONY'S CANOSSIAN SECONDARY SCHOOL",
      "ST. GABRIEL'S SECONDARY SCHOOL",
      "ST. HILDA'S SECONDARY SCHOOL",
      "ST. MARGARET'S SECONDARY SCHOOL",
      "ST. PATRICK'S SCHOOL",
      'SWISS COTTAGE SECONDARY SCHOOL',
      'TAMPINES SECONDARY SCHOOL',
      'TANGLIN SECONDARY SCHOOL',
      "TANJONG KATONG GIRLS' SCHOOL",
      'TANJONG KATONG SECONDARY SCHOOL',
      'TECK WHYE SECONDARY SCHOOL',
      'TEMASEK SECONDARY SCHOOL',
      'UNITY SECONDARY SCHOOL',
      'VICTORIA SCHOOL',
      'WEST SPRING SECONDARY SCHOOL',
      'WESTWOOD SECONDARY SCHOOL',
      'WHITLEY SECONDARY SCHOOL',
      'WOODGROVE SECONDARY SCHOOL',
      'WOODLANDS RING SECONDARY SCHOOL',
      'WOODLANDS SECONDARY SCHOOL',
      'XINMIN SECONDARY SCHOOL',
      'YIO CHU KANG SECONDARY SCHOOL',
      'YISHUN SECONDARY SCHOOL',
      'YISHUN TOWN SECONDARY SCHOOL',
      'YUAN CHING SECONDARY SCHOOL',
      'YUHUA SECONDARY SCHOOL',
      'YUSOF ISHAK SECONDARY SCHOOL',
      'YUYING SECONDARY SCHOOL',
      'ZHENGHUA SECONDARY SCHOOL',
      'ZHONGHUA SECONDARY SCHOOL',
      'ANDERSON JUNIOR COLLEGE',
      'ANGLO-CHINESE JUNIOR COLLEGE',
      'CATHOLIC JUNIOR COLLEGE',
      'INNOVA JUNIOR COLLEGE',
      'JURONG JUNIOR COLLEGE',
      'MERIDIAN JUNIOR COLLEGE',
      'MILLENNIA INSTITUTE',
      'NANYANG JUNIOR COLLEGE',
      'PIONEER JUNIOR COLLEGE',
      'SERANGOON JUNIOR COLLEGE',
      "ST. ANDREW'S JUNIOR COLLEGE",
      'TAMPINES JUNIOR COLLEGE',
      'VICTORIA JUNIOR COLLEGE',
      'YISHUN JUNIOR COLLEGE',
      'ANGLO-CHINESE SCHOOL (INDEPENDENT)',
      'CATHOLIC HIGH SCHOOL',
      "CHIJ ST. NICHOLAS GIRLS' SCHOOL",
      'DUNMAN HIGH SCHOOL',
      'HWA CHONG INSTITUTION',
      'MARIS STELLA HIGH SCHOOL',
      "METHODIST GIRLS' SCHOOL (PRIMARY)",
      "METHODIST GIRLS' SCHOOL (SECONDARY)",
      'NATIONAL JUNIOR COLLEGE',
      'NUS HIGH SCHOOL OF MATHEMATICS AND SCIENCE',
      'RAFFLES INSTITUTION',
      'RIVER VALLEY HIGH SCHOOL',
      'SCHOOL OF THE ARTS, SINGAPORE',
      "SINGAPORE CHINESE GIRLS' PRIMARY SCHOOL",
      "SINGAPORE CHINESE GIRLS' SCHOOL",
      'SINGAPORE SPORTS SCHOOL',
      "ST. JOSEPH'S INSTITUTION",
      'TEMASEK JUNIOR COLLEGE',
      'YISHUN INNOVA JUNIOR COLLEGE',
      'JURONG PIONEER JUNIOR COLLEGE',
      'ANDERSON SERANGOON JUNIOR COLLEGE',
      'TAMPINES MERIDIAN JUNIOR COLLEGE',
      'Ahmand Ibrahim Secondary School',
      'Brodrick Secondary School',
      'CHIJ Secondary',
      "Christian Brothers' Schools",
      'Clementi Woods Secondary School',
      'First Toa Payoh Secondary School',
      'Gan Eng Seng Secondary School',
      'Gan Seng Eng School',
      'Millennia Institute Junior College',
      'Millennia Junior College',
      'Paris Ris Crest School',
      'Pei Chun Primary School',
      "Peya Lebar Methodist Girls' School(Primary)",
      'Rosyth Primary School',
    ];

    this.grades = [
      { value: 'PRIMARY 1', label: this.translate.instant('PRIMARY 1') },
      { value: 'PRIMARY 2', label: this.translate.instant('PRIMARY 2') },
      { value: 'PRIMARY 3', label: this.translate.instant('PRIMARY 3') },
      { value: 'PRIMARY 4', label: this.translate.instant('PRIMARY 4') },
      { value: 'PRIMARY 5', label: this.translate.instant('PRIMARY 5') },
      { value: 'PRIMARY 6', label: this.translate.instant('PRIMARY 6') },
      { value: 'SECONDARY 1', label: this.translate.instant('SECONDARY 1') },
      { value: 'SECONDARY 2', label: this.translate.instant('SECONDARY 2') },
      { value: 'SECONDARY 3', label: this.translate.instant('SECONDARY 3') },
      { value: 'SECONDARY 4', label: this.translate.instant('SECONDARY 4') },
      { value: 'SECONDARY 5', label: this.translate.instant('SECONDARY 5') },
      { value: 'JUNIOR COLLEGE 1', label: this.translate.instant('JUNIOR COLLEGE 1') },
      { value: 'JUNIOR COLLEGE 2', label: this.translate.instant('JUNIOR COLLEGE 2') },
    ];

    this.examTypes = [
      {
        value: 'MID-YEAR EXAMINATION',
        label: this.translate.instant('MID-YEAR EXAMINATION'),
      },
      {
        value: 'PRELIMINARY EXAMINATION',
        label: this.translate.instant('PRELIMINARY EXAMINATION'),
      },
      {
        value: 'FINAL EXAMINATION',
        label: this.translate.instant('FINAL EXAMINATION'),
      },
      {
        value: 'SEMESTRAL ASSESSMENT 1',
        label: this.translate.instant('SEMESTRAL ASSESSMENT 1'),
      },
      {
        value: 'SEMESTRAL ASSESSMENT 2',
        label: this.translate.instant('SEMESTRAL ASSESSMENT 2'),
      },
      {
        value: 'CONTINUAL ASSESSMENT 1',
        label: this.translate.instant('CONTINUAL ASSESSMENT 1'),
      },
      {
        value: 'CONTINUAL ASSESSMENT 2',
        label: this.translate.instant('CONTINUAL ASSESSMENT 2'),
      },
      {
        value: 'DIAGNOSTIC TEST',
        label: this.translate.instant('DIAGNOSTIC TEST'),
      },
      {
        value: 'Bite-sized Assessment 1',
        label: this.translate.instant('Bite-sized Assessment 1'),
      },
      {
        value: 'Bite-sized Assessment 2',
        label: this.translate.instant('Bite-sized Assessment 2'),
      },
      {
        value: 'Class Test',
        label: this.translate.instant('Class Test'),
      },
      {
        value: 'Class Test 1',
        label: this.translate.instant('Class Test 1'),
      },
      {
        value: 'Class Test 2',
        label: this.translate.instant('Class Test 2'),
      },
      {
        value: 'Checkpoint 1',
        label: this.translate.instant('Checkpoint 1'),
      },
      {
        value: 'Combined Topical Test',
        label: this.translate.instant('Combined Topical Test'),
      },
      {
        value: 'Combined Topical Test 1',
        label: this.translate.instant('Combined Topical Test 1'),
      },
      {
        value: 'Combined Topical Test 2',
        label: this.translate.instant('Combined Topical Test 2'),
      },
      {
        value: 'Combined Topical Test 3',
        label: this.translate.instant('Combined Topical Test 3'),
      },
      {
        value: 'Continual Assessment',
        label: this.translate.instant('Continual Assessment'),
      },
      {
        value: 'End-of-year Examination',
        label: this.translate.instant('End-of-year Examination'),
      },
      {
        value: 'End of year Assessment',
        label: this.translate.instant('End of year Assessment'),
      },
      {
        value: 'End-Of-Year Review',
        label: this.translate.instant('End-Of-Year Review'),
      },
      {
        value: 'English Trial',
        label: this.translate.instant('English Trial'),
      },
      {
        value: 'English Trial Paper',
        label: this.translate.instant('English Trial Paper'),
      },
      {
        value: 'English Language Quiz',
        label: this.translate.instant('English Language Quiz'),
      },
      {
        value: 'English Language Test 1',
        label: this.translate.instant('English Language Test 1'),
      },
      {
        value: 'English Language Test 2',
        label: this.translate.instant('English Language Test 2'),
      },
      {
        value: 'English Practice 2',
        label: this.translate.instant('English Practice 2'),
      },
      {
        value: 'First Semestral Examination',
        label: this.translate.instant('First Semestral Examination'),
      },
      {
        value: 'Formative Assessment',
        label: this.translate.instant('Formative Assessment'),
      },
      {
        value: 'Grammar and Vocabulary Test',
        label: this.translate.instant('Grammar and Vocabulary Test'),
      },
      {
        value: 'Grammar and Vocabulary Practice 2',
        label: this.translate.instant('Grammar and Vocabulary Practice 2'),
      },
      {
        value: 'Holistic Assessment',
        label: this.translate.instant('Holistic Assessment'),
      },
      {
        value: 'Holistic Assessment 1',
        label: this.translate.instant('Holistic Assessment 1'),
      },
      {
        value: 'Holistic Assessment 2',
        label: this.translate.instant('Holistic Assessment 2'),
      },
      {
        value: 'Holistic Assessment 3',
        label: this.translate.instant('Holistic Assessment 3'),
      },
      {
        value: 'Language Use Test Term 2',
        label: this.translate.instant('Language Use Test Term 2'),
      },
      {
        value: 'Language Use Test Term 3',
        label: this.translate.instant('Language Use Test Term 3'),
      },
      {
        value: 'Language Use Test Term 4',
        label: this.translate.instant('Language Use Test Term 4'),
      },
      {
        value: 'Language Use and Comprehension',
        label: this.translate.instant('Language Use and Comprehension'),
      },
      {
        value: 'Language Use and Comprehension Review',
        label: this.translate.instant('Language Use and Comprehension Review'),
      },
      {
        value: 'Language Review 1',
        label: this.translate.instant('Language Review 1'),
      },
      {
        value: 'Mathematics Quiz 1',
        label: this.translate.instant('Mathematics Quiz 1'),
      },
      {
        value: 'Mathematics Quiz 2',
        label: this.translate.instant('Mathematics Quiz 2'),
      },
      {
        value: 'Mathematics Quiz 3',
        label: this.translate.instant('Mathematics Quiz 3'),
      },
      {
        value: 'Mathematics Worksheet',
        label: this.translate.instant('Mathematics Worksheet'),
      },
      {
        value: 'Mid Year Assessment',
        label: this.translate.instant('Mid Year Assessment'),
      },
      {
        value: 'Mid-year Examination',
        label: this.translate.instant('Mid-year Examination'),
      },
      {
        value: 'Mid-Year Express',
        label: this.translate.instant('Mid-Year Express'),
      },
      {
        value: 'Milestone Check 1',
        label: this.translate.instant('Milestone Check 1'),
      },
      {
        value: 'Milestone Check 2',
        label: this.translate.instant('Milestone Check 2'),
      },
      {
        value: 'Mini Test 1 and 2',
        label: this.translate.instant('Mini Test 1 and 2'),
      },
      {
        value: 'Mini Test 1',
        label: this.translate.instant('Mini Test 1'),
      },
      {
        value: 'Mini Test 2',
        label: this.translate.instant('Mini Test 2'),
      },
      {
        value: 'Mini Test 3',
        label: this.translate.instant('Mini Test 3'),
      },
      {
        value: 'Mini Test 4',
        label: this.translate.instant('Mini Test 4'),
      },
      {
        value: 'Mock Test',
        label: this.translate.instant('Mock Test'),
      },
      {
        value: 'Modular Assessment 1',
        label: this.translate.instant('Modular Assessment 1'),
      },
      {
        value: 'Modular Assessment 2',
        label: this.translate.instant('Modular Assessment 2'),
      },
      {
        value: 'Practice Paper 1',
        label: this.translate.instant('Practice Paper 1'),
      },
      {
        value: 'Practice Paper 2',
        label: this.translate.instant('Practice Paper 2'),
      },
      {
        value: 'Practice Paper 3',
        label: this.translate.instant('Practice Paper 3'),
      },
      {
        value: 'Practice Paper Term 4',
        label: this.translate.instant('Practice Paper Term 4'),
      },
      {
        value: 'Preliminary Assessment',
        label: this.translate.instant('Preliminary Assessment'),
      },
      {
        value: 'Preliminary Two Examination',
        label: this.translate.instant('Preliminary Two Examination'),
      },
      {
        value: 'Preliminary Examination 1',
        label: this.translate.instant('Preliminary Examination 1'),
      },
      {
        value: 'Reading Comprehension Task',
        label: this.translate.instant('Reading Comprehension Task'),
      },
      {
        value: 'Revision',
        label: this.translate.instant('Revision'),
      },
      {
        value: 'Review Paper',
        label: this.translate.instant('Review Paper'),
      },
      {
        value: 'Review Paper 1',
        label: this.translate.instant('Review Paper 1'),
      },
      {
        value: 'Review Assessment 1',
        label: this.translate.instant('Review Assessment 1'),
      },
      {
        value: 'Review Assessment 2',
        label: this.translate.instant('Review Assessment 2'),
      },
      {
        value: 'Revision Paper',
        label: this.translate.instant('Revision Paper'),
      },
      {
        value: 'Revision Paper 2',
        label: this.translate.instant('Revision Paper 2'),
      },
      {
        value: 'Semestral Assessment',
        label: this.translate.instant('Semestral Assessment'),
      },
      {
        value: 'Semestral Examination 1',
        label: this.translate.instant('Semestral Examination 1'),
      },
      {
        value: 'Semestral Examination 2',
        label: this.translate.instant('Semestral Examination 2'),
      },
      {
        value: 'Short Language Paper',
        label: this.translate.instant('Short Language Paper'),
      },
      {
        value: 'Summative Assessment',
        label: this.translate.instant('Summative Assessment'),
      },
      {
        value: 'Term Review 1',
        label: this.translate.instant('Term Review 1'),
      },
      {
        value: 'Term Review 2',
        label: this.translate.instant('Term Review 2'),
      },
      {
        value: 'Term 1 Topical Review',
        label: this.translate.instant('Term 1 Topical Review'),
      },
      {
        value: 'Term 2 Revision',
        label: this.translate.instant('Term 2 Revision'),
      },
      {
        value: 'Term 3 Revision',
        label: this.translate.instant('Term 3 Revision'),
      },
      {
        value: 'Term 4 Revision',
        label: this.translate.instant('Term 4 Revision'),
      },
      {
        value: 'Term Assessment',
        label: this.translate.instant('Term Assessment'),
      },
      {
        value: 'Termly Assessment',
        label: this.translate.instant('Termly Assessment'),
      },
      {
        value: 'Termly Assessment 2',
        label: this.translate.instant('Termly Assessment 2'),
      },
      {
        value: 'Term 1 Weighted Assessment',
        label: this.translate.instant('Term 1 Weighted Assessment'),
      },
      {
        value: 'Term 3 Weighted Assessment',
        label: this.translate.instant('Term 3 Weighted Assessment'),
      },
      {
        value: 'Tropical Test 1',
        label: this.translate.instant('Tropical Test 1'),
      },
      {
        value: 'Topical Review 1',
        label: this.translate.instant('Topical Review 1'),
      },
      {
        value: 'Topical Review 2',
        label: this.translate.instant('Topical Review 2'),
      },
      {
        value: 'Topical Review 3',
        label: this.translate.instant('Topical Review 3'),
      },
      {
        value: 'Topical Assessment 1',
        label: this.translate.instant('Topical Assessment 1'),
      },
      {
        value: 'Topical Assessment 2',
        label: this.translate.instant('Topical Assessment 2'),
      },
      {
        value: 'Topical Assessment 3',
        label: this.translate.instant('Topical Assessment 3'),
      },
      {
        value: 'Topical Test',
        label: this.translate.instant('Topical Test'),
      },
      {
        value: 'Topical Quiz 1',
        label: this.translate.instant('Topical Quiz 1'),
      },
      {
        value: 'Topical Quiz 2',
        label: this.translate.instant('Topical Quiz 2'),
      },
      {
        value: 'Topical Quiz 3',
        label: this.translate.instant('Topical Quiz 3'),
      },
      {
        value: 'Unit Review 1',
        label: this.translate.instant('Unit Review 1'),
      },
      {
        value: 'Weighted Assessment',
        label: this.translate.instant('Weighted Assessment'),
      },
      {
        value: 'Weighted Assessment 1',
        label: this.translate.instant('Weighted Assessment 1'),
      },
      {
        value: 'Weighted Assessment 2',
        label: this.translate.instant('Weighted Assessment 2'),
      },
      {
        value: 'Weighted Assessment 3',
        label: this.translate.instant('Weighted Assessment 3'),
      },
      {
        value: 'Worksheet 2',
        label: this.translate.instant('Worksheet 2'),
      },
    ];

    this.papers = [
      { value: 'Booklet A and B', label: this.translate.instant('Booklet A and B') },
      { value: 'Booklet A, B & C', label: this.translate.instant('Booklet A, B & C') },
      { value: 'Booklet A', label: this.translate.instant('Booklet A') },
      { value: 'Booklet B', label: this.translate.instant('Booklet B') },
      { value: 'Paper 1 & 2', label: this.translate.instant('Paper 1 & 2') },
      { value: 'Paper 1, 2 and 3', label: this.translate.instant('Paper 1, 2 and 3') },
      { value: 'Paper 4', label: this.translate.instant('Paper 4') },
      { value: 'Paper 1 (Writing)', label: this.translate.instant('Paper 1 (Writing)') },
      { value: 'Review 1', label: this.translate.instant('Review 1') },
      { value: 'Review 2', label: this.translate.instant('Review 2') },
      { value: 'Revision A and B', label: this.translate.instant('Revision A and B') },
      { value: 'Section A,B,C and D', label: this.translate.instant('Section A,B,C and D') },
      { value: 'Section A, B & C', label: this.translate.instant('Section A, B & C') },
      { value: 'Section A and B', label: this.translate.instant('Section A and B') },
      { value: 'Section A', label: this.translate.instant('Section A') },
      { value: 'Section B', label: this.translate.instant('Section B') },
      { value: 'Section C', label: this.translate.instant('Section C') },
      { value: 'Set A', label: this.translate.instant('Set A') },
      { value: 'Set B', label: this.translate.instant('Set B') },
      { value: 'Test 1', label: this.translate.instant('Test 1') },
      { value: 'Test 2', label: this.translate.instant('Test 2') },
      { value: 'Test 3', label: this.translate.instant('Test 3') },
      { value: 'Test 1 and 2', label: this.translate.instant('Test 1 and 2') },
      { value: 'Term 1', label: this.translate.instant('Term 1') },
      { value: 'Term 2', label: this.translate.instant('Term 2') },
      { value: 'Term 3', label: this.translate.instant('Term 3') },
      { value: 'Term 1 and 2', label: this.translate.instant('Term 1 and 2') },
      { value: 'Term 3 and 4', label: this.translate.instant('Term 3 and 4') },
      { value: 'Units 1 and 2', label: this.translate.instant('Units 1 and 2') },
    ];
  }

  sortExamDataByValue(pastExamData: PastExamData[]) {
    return pastExamData.sort((a, b) => a.value.localeCompare(b.value));
  }
}
